// src/components/BotonIAFlotante.js
import React from "react";

export default function BotonIAFlotante({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Asistente IA"
      aria-label="Asistente IA"
      className="boton-ia"
      style={{
        position: "fixed", bottom: 24, right: 24, zIndex: 40,
        width: 56, height: 56, borderRadius: "50%", border: "none",
        padding: 0, cursor: "pointer",
        background: "white",
        boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "transform 0.2s, box-shadow 0.2s",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,0.25)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.18)"; }}
    >
      <img src="/icons/renty-logo.png" alt="Renty" style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover" }} />
    </button>
  );
}